import { useState } from "react";
import { FaEdit, FaRegEdit, FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  isAfterTime,
  orderFormatedDate,
  timeBetweenHrs,
  timeBetweenMins,
} from "../../utils/dateUtil";

function WalletLogItem(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [item, setItem] = useState(props.item);

  return (
    <>
      <tr>
        <td> {item.id} </td>
                <td className="align-middle">{item.type}</td>
        <td className="align-middle">{item.amount}</td>
        <td className="align-middle">{item.reason}</td>
        <td> {orderFormatedDate(item.updated_at)} </td>


      </tr>
    </>
  );
}

export default WalletLogItem;
